module.exports = __webpack_public_path__ + "static/media/logo_smart_search_facial.ccea491c.png";